import config from "config";

// Eventually we should lazy load these to reduce runtime load
import StaticConfigAuthDriver from "./drivers/StaticConfigAuthDriver";
import CognitoAuthDriver from "./drivers/CognitoAuthDriver";
import NoAuthDruver from "./drivers/NoAuthDriver";
import BaseAuthDriver from "./drivers/BaseAuthDriver";

const driverMap = {
  __insecure__none: NoAuthDruver.init(),
  "static-config": StaticConfigAuthDriver.init(),
  "aws-cognito": CognitoAuthDriver.init()
};

const AuthDriver = driverMap[config("authDriver")] || BaseAuthDriver.init();

export { AuthDriver, AuthDriver as default };
